class DetailsAccordion extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
    window.addEventListener('resize', this.updateOpenStatus.bind(this));
    this.updateOpenStatus();
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
    this.setAttribute('open', true);
  }

  close() {
    this.detailsContainer.removeAttribute('open');
    this.removeAttribute('open');
  }

  updateOpenStatus() {
    let isMobileMQ = window.matchMedia('(max-width: 899px)');

    if(isMobileMQ.matches)
    {
      this.close();
    }
    else
    {
      this.open();
    }
  }
}

customElements.define('details-accordion', DetailsAccordion);
